"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationSearch = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
require("./NavigationSearch.scss");
const spa_core_1 = require("@episerver/spa-core");
const useOnClickOutside_1 = __importDefault(require("app/hooks/useOnClickOutside"));
const NavigationSearch = (props) => {
    var _a, _b;
    const ctx = (0, spa_core_1.useEpiserver)();
    const history = (0, react_router_dom_1.useHistory)();
    const ref = (0, react_1.useRef)(null);
    const searchbtn = (0, react_1.useRef)(null);
    const formref = (0, react_1.useRef)(null);
    const inputref = (0, react_1.useRef)(null);
    const [searchActive, setSearchActive] = (0, react_1.useState)(false);
    const [initialState, setInitialState] = (0, react_1.useState)(true);
    const searchPageUrl = typeof (props.labels.searchPageRedirectUrl) === 'string' ? props.labels.searchPageRedirectUrl
        : (((_a = props.labels.searchPageRedirectUrl) === null || _a === void 0 ? void 0 : _a.value) ? new URL(props.labels.searchPageRedirectUrl.value).pathname : null);
    const placeholder = typeof (props.labels.navSearchInputPlaceholder) === 'string' ? props.labels.navSearchInputPlaceholder : (_b = props.labels.navSearchInputPlaceholder) === null || _b === void 0 ? void 0 : _b.value;
    const isSSR = ctx.isServerSideRendering();
    const toSearchPage = (event) => {
        event.preventDefault();
        setSearchActive(false);
        if (searchbtn.current) {
            searchbtn.current.removeAttribute('tabindex');
            searchbtn.current.removeAttribute('aria-hidden');
        }
        const formdata = new FormData(event.target);
        const s = formdata.get('term').toString();
        event.target.querySelector('input').value = '';
        if (searchPageUrl) {
            s && s.length > 0 ? history.push(`${searchPageUrl}?q=${encodeURIComponent(s)}`) : history.push(searchPageUrl);
        }
    };
    const closeSearch = () => {
        if (formref.current.classList.contains('active')) {
            setSearchActive(false);
            if (searchbtn.current) {
                searchbtn.current.removeAttribute('tabindex');
                searchbtn.current.removeAttribute('aria-hidden');
                searchbtn.current.focus();
            }
            formref.current.removeEventListener('keydown', closeSearchOnEsc);
            setTimeout(() => {
                formref.current.classList.replace('hidden', 'initial-state');
            }, 500);
        }
    };
    const closeSearchOnEsc = (e) => {
        e.code === 'Escape' && closeSearch();
    };
    const openSearch = () => {
        setSearchActive(true);
        setInitialState(false);
        formref.current.addEventListener('keydown', closeSearchOnEsc);
        setTimeout(() => {
            inputref.current.focus();
            if (searchbtn.current) {
                searchbtn.current.setAttribute('tabindex', -1);
                searchbtn.current.setAttribute('aria-hidden', true);
            }
        }, 300);
    };
    if (!isSSR)
        (0, useOnClickOutside_1.default)(ref, () => {
            closeSearch();
        });
    if (props.inHeader) {
        return react_1.default.createElement("div", { className: 'navigation-search position-relative d-flex d-md-none align-items-center justify-content-center', ref: ref },
            react_1.default.createElement("button", { ref: searchbtn, className: 'icon-search p-0 fw-bold text-end', onClick: () => openSearch(), "aria-controls": 'mobile_search_form', "aria-expanded": searchActive },
                react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.labels, field: 'searchButtonMobileAriaLabel', className: 'visually-hidden' })),
            react_1.default.createElement("form", { role: "search", id: 'mobile_search_form', className: `position-absolute bg-white${isSSR || initialState ? ' initial-state' : searchActive ? ' active' : ' hidden'}`, onSubmit: e => { toSearchPage(e); }, "aria-hidden": !searchActive, ref: formref },
                react_1.default.createElement("label", null,
                    react_1.default.createElement("span", { className: 'visually-hidden' }, placeholder),
                    react_1.default.createElement("input", { placeholder: placeholder, className: 'border-1 border-black', type: "text", name: 'term', tabIndex: searchActive ? 0 : -1, ref: inputref })),
                react_1.default.createElement("button", { type: 'submit', tabIndex: searchActive ? 0 : -1, className: 'position-absolute top-50 translate-middle-y border-0 bg-none d-flex align-items-center justify-content-center h-100' },
                    react_1.default.createElement("span", { className: 'icon-search fw-bold', "aria-hidden": true }),
                    react_1.default.createElement("span", { className: 'visually-hidden' },
                        react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.labels, field: "searchButtonText" })))));
    }
    else {
        return react_1.default.createElement("div", { className: 'd-none d-md-flex navigation-search row g-5 g-md-0' },
            react_1.default.createElement("div", { className: 'col-12' },
                react_1.default.createElement("form", { role: "search", className: 'm-md-2 position-relative bg-white', onSubmit: e => { toSearchPage(e); } },
                    react_1.default.createElement("label", { className: 'w-100' },
                        react_1.default.createElement("span", { className: 'visually-hidden' }, placeholder),
                        react_1.default.createElement("input", { placeholder: placeholder, className: 'w-100 border-1 border-black', type: "text", name: 'term' })),
                    react_1.default.createElement("button", { type: 'submit', className: 'position-absolute top-50 end-0 translate-middle-y border-0 bg-none d-flex align-items-center justify-content-center h-100' },
                        react_1.default.createElement("span", { className: 'icon-search', "aria-hidden": true }),
                        react_1.default.createElement("span", { className: 'visually-hidden' },
                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.labels, field: "searchButtonText" }))))));
    }
};
exports.NavigationSearch = NavigationSearch;
exports.default = exports.NavigationSearch;
